import { createStore } from "vuex";

import corp from "@/store/modules/corp";
import auth from "@/store/modules/auth";
import body from "@/store/modules/body";

const store = createStore({
  modules: {
    corp: corp,
    auth: auth,
    body: body
  },
});

export default store;
